<div class="dialog-container">
    <h1 mat-dialog-title class="dialog-title">{{data.title}}</h1>
    <div mat-dialog-content class="dialog-content">
        <span>
            {{data.message}}
        </span>
        <br>
        <!-- 라벨은 호출자가 정한다. 예전에는 '목적' 이 박혀 있어서 조직 추가처럼
             목적과 무관한 입력에도 '목적' 이 떴다. 미지정 시에만 '목적' 을 쓴다. -->
        <mat-form-field class="input" *ngIf="data.input" appearance="outline">
            <mat-label>{{ data.inputLabel || '목적' }}</mat-label>
            <input matInput #text type="text" [(ngModel)]="input"/>
        </mat-form-field>
    </div>
    <mat-dialog-actions align="end">
        <button mat-raised-button color="primary" (click)="okButtonClicked(data.okHandle)" >확인</button>
        <button mat-raised-button (click)="cancelButtonClicked(data.cancelHandle)" *ngIf="data.cancelHandle">취소</button>
    </mat-dialog-actions>
</div>
